/* eslint-disable */
/* TODO: If you edit this file remove eslint-disable and fix linting errors in this file. */
const pusher = require('pusher-js');
// @ts-ignore
window.Pusher = pusher;
